// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"367":"b536a0f1","932":"080de1a6"}[chunkId] || chunkId) + "." + {"367":"15e7c73d973c443a","374":"ca3adf624a6db174","700":"c13bee08af676c68","932":"0c2dce315b564f2a"}[chunkId] + ".js";
};